import React from 'react';

export const AppContext = React.createContext(null);

AppContext.displayName = 'ApplicationContext';

export const withAppContext = (Component) => {
    const WrappedComponent = (props) => (
        <AppContext.Consumer>
            {(contextValues) => <Component {...contextValues} {...props} />}
        </AppContext.Consumer>
    );

    WrappedComponent.displayName = `withAppContext(${Component.displayName || Component.name || 'Component'})`;

    return WrappedComponent;
};

export const AppProvider = ({ children, ...props }) => {
    const [state, setState] = React.useState(props || {});

    const updateAppContext = (values) => setState({ ...state, ...values });
    const setCurrentError = (currentError) =>
        updateAppContext({ currentError });
    const handleError = (currentError) => setCurrentError(currentError);

    const contextValue = {
        ...state,
        updateAppContext,
        setCurrentError,
        handleError,
    };

    return (
        <AppContext.Provider value={contextValue}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => React.useContext(AppContext);
